import russia from "../assets/images/flags/russia.jpg"
import usFlag from "../assets/images/flags/us.jpg"

/**
 * Поддерживаемые языки EyeHub.
 *
 * Ключи соответствуют кодам локалей в i18n.js (SUPPORTED_LOCALES)
 * и поддерживаемым локалям backend.
 */
const languages = {
  ru: {
    label: "Русский",
    flag: russia,
  },
  en: {
    label: "English",
    flag: usFlag,
  },
}

export default languages
